export const TITLE_COLOR = '#eb40c2'